import React, { createContext, useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { AllUser, GeneralSettings} from '../../environment/GlobalApi';
import { PrivateAxios } from '../../environment/AxiosInstance';


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(sessionStorage.getItem("token") || '');
    const [userDetailsLogin, setUserDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [User, setUser] = useState([]);
    const [companyDetails, setCompanyDetails] = useState([]);
    const [getCustomer, setCustomer] = useState([]);
    const [getUomData , setUomData] = useState([]);
    const [productData, setProduct] = useState([]);
    const [getGeneralSettingssymbol, setGeneralSettings] = useState(false);
    const [getGeneralSettingsDAddress, setGeneralSettingsDAddress] = useState(false);
    const [getGeneralSettingsCAddress, setGeneralSettingsCAddress] = useState(false);
    const [getGeneralSettingsSignature, setGeneralSettingsSignature] = useState(false);
    const [category, setCategory] = useState([]);
    const [mode, setMode] = useState([]);
    const [status, setStatus] = useState([]);
    const [holidayList, setHolidayList] = useState([]);
    const [officeTimeList, setOfficeTimeList] = useState([]);
  const [userPermissions, setUserPermission] = useState([]);
    //Login Store in localstorage
    const StoreToken = (token) => {
        sessionStorage.setItem("token", token);
        setToken(token); // Assuming setToken updates the state with the token
        //localStorage.setItem("token", token);
        //setToken(token)
        return <Navigate to="/v1/welcome" />;
    };
const MatchPermission = (permission) => {
       
        if (userPermissions.length > 0) {
            const hasPermission = permission.some(permission =>
                userPermissions.includes(permission)
            );
            return hasPermission;
        } else {
            return false;
        }
    }
    //Logout from Dashboard
    const Logout = () => {
        setToken(""); // Clear token state
        sessionStorage.removeItem("token"); // Remove token from sessionStorage
        return <Navigate to="/" />;
    }

    //Call all necessary function
    const AllUsers = async () => {
        const newUserArray = await AllUser();
        if (newUserArray == 401) {
            Logout();
        }
        setUser(newUserArray.user);
    }

const GetCompanyDetails = async () => {
  try {
    const response = await PrivateAxios.get("/company/company-info");
    const companyList = response.data.data;
    setCompanyDetails(companyList);
   
  } catch (error) {
    console.error("Error fetching company data:", error);
  }
};

    useEffect(() => {
       
        if (token) {
          
            setUserDetails(jwtDecode(token));
            AllUsers();
           // companyDetails();
           GetCompanyDetails()
        }
    }, [token])


    let isLoggedIn = !!token; //return true false

    return <AuthContext.Provider value={{ StoreToken, MatchPermission, token, userDetailsLogin,isLoading, setIsLoading, Logout, isLoggedIn,  User, companyDetails }}>
        {children}
    </AuthContext.Provider>
}
//console.log(sessionStorage.getItem("token"));
export const UserAuth = () => {
    const authCOntextValue = useContext(AuthContext);
    if (!authCOntextValue) {
        throw new Error("useAuth used outside of the provider")
    }
    return authCOntextValue;
}